import { render } from "./FacebookAdReel.vue?vue&type=template&id=38b0b1e1&scoped=true"
import script from "./FacebookAdReel.vue?vue&type=script&lang=js"
export * from "./FacebookAdReel.vue?vue&type=script&lang=js"

import "./FacebookAdReel.vue?vue&type=style&index=0&id=38b0b1e1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38b0b1e1"]])

export default __exports__